import { get } from 'lodash'
import { required, logMinDuration, forbiddenFutureDate } from 'utils/validation'
import moment from 'moment'

const validate = values => {
  const weeksCount = get(values, 'weeksCount')

  const addWeek = weeksCount && weeksCount > 0 ? weeksCount-1 : 0

  return {
    description: required(get(values, 'description')),
    startDate: forbiddenFutureDate(moment(get(values, 'startDate')).add(addWeek, 'weeks')),
    duration: required(get(values, 'duration')) || logMinDuration(30)(get(values, 'duration')),
    weeksCount:  required(weeksCount)
  }
}

export default validate
